module.exports = new __parcel__URL__("post-default.e177bce2.jpg").toString();